import { config, handleResponse } from '../../_helpers';

export const portRateServices = {
    getAllPortRates,
    getPortRates,
    createPortRate,
    updatePortRate,
    getPortRateById,
    deletePortRates,
    activation,
    searchPortRates,
    getPortListByCode,
    portRatesGroupByChargeCode,
    loadPortRatesByCharge,
};
function getAllPortRates() {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/PortRates`, requestOptions).then(handleResponse);
}
function getPortRates(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/PortRates/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/PortRates/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function createPortRate(portRate, userProfile) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            dateEffective: portRate.dateEffective,
            chargeCode: portRate.chargeCode,
            branchCode: portRate.branchCode,
            portCode: portRate.portCode,
            stdRateWvat: portRate.stdRateWvat,
            userCreated: userProfile.userId
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/PortRates`, requestOptions).then(handleResponse);
}
function updatePortRate(portRate, userProfile) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify({
            dateEffective: portRate.dateEffective,
            chargeCode: portRate.chargeCode,
            branchCode: portRate.branchCode,
            portCode: portRate.portCode,
            stdRateWvat: portRate.stdRateWvat,
            userModified: userProfile.userId
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/PortRates/update/${portRate.id}`, requestOptions).then(handleResponse);
}
function getPortRateById(id) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/PortRates/get/${id}`, requestOptions).then(handleResponse);
}
function deletePortRates(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/PortRates/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };

    return fetch(`${config.apiUrl}/PortRates/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function searchPortRates(take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/PortRates/load?filter=${filter}&search=${search}&take=${take}`, requestOptions).then(handleResponse);
}
function getPortListByCode(charge, branch) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/PortRates/ReadListByCode?chargecode=${charge}&branchcode=${branch}`, requestOptions).then(handleResponse);
}
function portRatesGroupByChargeCode(skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/PortRates/portRatesGroupByChargeCode?skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/PortRates/portRatesGroupByChargeCode?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function loadPortRatesByCharge(charge, skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/PortRates/loadPortRatesByCharge?chargeCode=${charge}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/PortRates/loadPortRatesByCharge?chargeCode=${charge}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}